export default __webpack_public_path__ + "static/media/HelpButtonLocationMobile.f42ae3de.png";